interface LightningProps {
  className?: string;
}

const LightningIcon = (props: LightningProps) => {
  const { className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 22"
      className={className}
    >
      <path
        fill="url(#a)"
        d="m4.625 22 .688-9.075L.75 11.621a.2.2 0 0 1-.117-.294L7.375 0l-.688 9.075 4.563 1.304a.2.2 0 0 1 .117.294L4.625 22Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="6"
          x2="6"
          y1="0"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B53CE" />
          <stop offset="1" stopColor="#8395F7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default LightningIcon;
